import {format} from "date-fns";

export const formatDateUTC = (date: string | Date, formatter: 'short' | 'long' = 'short') => format(new Date(date), formatter === 'short' ? 'dd/MM/yyyy HH:mm:ss' : 'dd MMM yyyy HH:mm:ss');